import { advertiserCards } from './advertiser'
import { publisherCards, publisherListAllCards } from './publisher'

const cardsByType = {
  publisher: publisherCards,
  advertiser: advertiserCards,
  listAll: {
    publisher: publisherListAllCards,
    advertiser: advertiserCards
  }
}

export default cardsByType
